import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
  Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import {
  BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading';
import Printd from 'printd'
import index from '../../../utils/index'
import Multiselect from 'vue-multiselect';

export default {
  name: 'bag-details-invoice',
  components: {
    Paginate,
    DatePicker,
    BasicSelect,
    VueElementLoading,
    Multiselect
    
  },
  props: [],
  data() {
    return {
      showList: false,
      viewBagListmodel: false,
      viewBagOctroilListModel: false,
      isLoadingBag: false,
      InvoiceListArray: [],
      BagDetailsArray: [],
      BagOctroilListArray: [],
      connectiontypelist: [],
      hubzonelist: [],
      connectiontypeitem: {
        id: '',
        text: ''
      },
      hubnamelist: [],
      hubnameitem: {
        id: '',
        text: ''
      },
      connectionnamelist: [],
      connectionnameitem: {
        id: '',
        text: '',
        route: ''
      },
      hubzoneitem: {
        id: '',
        text: ''
      },
      hubzone: '',
      hubzoneLoading: '',
      isLoading: false,
      hubnameLoading: '',
      connectionnameLoading: '',
      gstregnoLoading: '',
      hubname: '',
      connectiontype: '',
      connectionname: '',
      fromdate: '',
      todate: '',
      DestinationHubID: '',
      GSTRegNo: '',
      InvoiceNo: '',
      InvoiceDate: '',
      Connection: '',
      VehicleNo: '',
      createdBy: '',
      PrintDate: '',
      PrintBy: '',
      actualRoute: '',
      isLoadingSearch: false,
      pageCount: 0,
      pageNo: 0,
      limit: 10,
      totalRows: 0,
      connectionnameError: '',
      emailIdErrorMSG:'',
      emailIdValidationMSG:'',
      mailId:'',
      regForMail: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      invoiceNoForMail:'',
      viewBrooksNdBondModel:false,
      allShipmentsCount:0,
      allBagsCount:0,
      printConfig : false
    }
  },
  computed: {},
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
    TotalMRP: function(data) {
      var resultMRP;
      for (var i = 0; i < data.length; i++) {
        resultMRP = data[i].ordervalue
      }
      if (resultMRP == null) {
        return 0
      }
      var total = data.reduce(function(totalMRP, item) {
        return totalMRP + parseFloat(item.ordervalue);
      }, 0);
      var with2Decimals = total.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
      return with2Decimals
    },
    ShipmentCount: function(data) {
      if (data.length == 0) {
        return 0
      } else {
        return data.length
      }
    },
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext)
    this.Hubid = userdetail[0].HubId;
    this.warehouseid = userdetail[0].warehouseid;
    this.createdBy = userdetail[0].email;
    this.getRouteType();
    this.getHubZone();
  },
  methods: {
    getHubZone() {
      this.hubzoneLoading = 'Loading Hub Zone...'
      var HubZoneListData = []
      this.input = ({})
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubzone/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubzoneLoading = ''
          if (result.data.ResultCode == 100) {
          HubZoneListData = result.data.ResponseData;
          for (var i = 0; i < HubZoneListData.length; i++) {
            this.hubzonelist.push({
              id: HubZoneListData[i].hubzoneid,
              text: HubZoneListData[i].hubzonename
            })
          }
        }
        else{
          HubZoneListData = []
        }
        }, error => {
          this.hubzoneLoading = ''
          console.error(error)
        })
    },
    selectHubZone(hubzoneitem) {
      this.hubzoneitem = hubzoneitem
      this.hubzone = this.hubzoneitem.text
      this.hubnamelist = []
      this.hubnameitem = {
        id: '',
        text: ''
      }
      this.hubname = ''
      this.connectionnamelist = []
      this.connectionnameitem = {
        id: '',
        text: '',
        route: ''
      }
      this.connectionname = ''
      this.actualRoute = ''
			this.$validator.reset()
      if (this.hubzone != '') {
        this.getHubName()
      }
    },
    getRouteType() {
      this.connectiontypelist.push({
        id: 0,
        text: 'Network'
      }, {
        id: 1,
        text: 'Local'
      }, {
        id: 3,
        text: 'LineHaul'
      }, {
        id: 4,
        text: 'Local-TP'
      },{
        id: 5,
        text: 'BrooksNBonds'
      })
    },
    getHubName() {
      this.hubnameLoading = 'Loading Hub...'
      var HubNameData = []
      this.input = ({
        hubZoneId: this.hubzoneitem.id
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubnameLoading = ''
          if (result.data.ResultCode == 100) {
          HubNameData = result.data.ResponseData
          for (var i = 0; i < HubNameData.length; i++) {
            this.hubnamelist.push({
              id: HubNameData[i].HubID,
              text: HubNameData[i].HubName + ' (' + HubNameData[i].HubID + ')'
            })
          }
        }
        else{
          HubNameData = []
        }
        }, error => {
          this.hubnameLoading = ''
          console.error(error)
        })
    },
    getConnectionName() {
      this.connectionnameLoading = 'Loading Connection Name...'
      if (this.hubnameitem.text == '' && this.connectiontype == '') {
        return false;
      } else {
        var self = this
        var userToken = window.localStorage.getItem('userToken')
        var myStr = userToken.replace(/"/g, '');
        this.input = {
          source: parseInt(self.hubnameitem.id),
          type: parseInt(self.connectiontypeitem.id)
        }
        axios({
            method: 'POST',
            'url': apiUrl.api_url_hubops + 'getroutemaster',
            'data': this.input,
            'headers': {
              'authorization': 'authkey xB84JJ89Hd25'
            }
          })
          .then(result => {
            this.connectionnameLoading = ''
            if (result.data.ResultCode == 100) {
              var ConnectionNameData = result.data.ResponseData;
              this.connectionnameError = ''
              for (var i = 0; i < ConnectionNameData.length; i++) {
                this.connectionnamelist.push({
                  id: ConnectionNameData[i].ConnectionID,
                  text: ConnectionNameData[i].ConnectionName + ' (TP- ' + ConnectionNameData[i].Stoppoints.length + ')',
                  route: ConnectionNameData[i].FullConnectionName
                })
              }
            } else {
              this.connectionnameError = "No Connection found"
            }
          }, error => {
						this.connectionnameLoading = ''
						this.connectionnameError = ''
            this.$alertify.error("Connection API Error")
            console.error(error)
          })
      }
    },
    getdate(date) {
      var today = new Date(date);
      var dd = today.getDate();
      var mm = today.getMonth() + 1; //January is 0!
      var yyyy = today.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }
      var today = yyyy + '-' + mm + '-' + dd;
      return today;
    },
    getInvoiceList() {
      this.totalRows = 0
      this.InvoiceListArray = []
      this.showList = true
      this.isLoading = true;
      var FromDate = this.getdate(this.fromdate)
      var ToDate = this.getdate(this.todate)
      this.input = ({});
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + 'getScheduledListForGenerateInvoice?connectionId=' + this.connectionnameitem.id + '&startDate=' + FromDate + '&endDate=' + ToDate + '&offset=' + this.pageNo + '&limit=' + this.limit,
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.isLoading = false;
          if (result.data.ResultCode == 100) {
            this.InvoiceListArray = result.data.ResponseData;
            this.$alertify.success(result.data.ReturnMessage);
            this.totalRows = result.data.TotalCount
            if (this.totalRows < 10) {
              this.pageCount = 1
            } else {
              this.pageCount = Math.ceil(this.totalRows / 10);
            }
          } else {
            this.$alertify.error(result.data.ReturnMessage);
          }
        }, error => {
          this.isLoading = false;
          console.error(error)
        })
    },
    getPaginationData(pageNum) {
      this.pageNo = (pageNum - 1)
      this.getInvoiceList()
    },
    getBagDetails(data) {
      this.BagDetailsArray = []
      this.InvoiceNo = data.invoiceno
      this.VehicleNo = data.vehicleno;
      this.InvoiceDate = data.invoicedate;
      this.DestinationHubID = data.hubid
      //this.InvoiceNo="INV1567326201973736"
      this.PrintBy = this.createdBy
      this.PrintDate = new Date();
      this.allShipmentsCount = 0;
      this.allBagsCount = 0;
      this.isLoadingBag = true
      this.Connection = '';
      this.printConfig = false;
      this.input = ({});

      let api = 'getBagDetailsForGenerateInvoice';
      if(this.connectiontypeitem && this.connectiontypeitem.id == 5){
        api = 'getBagDetailsForGenerateInvoiceBrookBond';
        this.viewBrooksNdBondModel = true;
      }else{
        this.viewBagListmodel = true;
      }

      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + api + '?invoiceNo=' + this.InvoiceNo,
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        })
        .then(result => {
          this.isLoadingBag = false
          if (result.data.ResultCode == 100) {
            this.printConfig =  index.configRolesCheck(result.data.config.pr_web_roles);
            this.BagDetailsArray    = result.data.ResponseData;

            this.allShipmentsCount  = result.data.totalShipments;
            this.allBagsCount       = result.data.totalBags;

            if (this.BagDetailsArray.length > 0) {
              //this.DestinationHubID = this.BagDetailsArray[0].bagdestinationhubid;
              // this.Connection = this.BagDetailsArray[0].connectionname;
              this.Connection = (this.connectiontypeitem && this.connectiontypeitem.id == 5) ? this.BagDetailsArray[0][0].connectionname : this.BagDetailsArray[0].connectionname;
              this.getHubDetails()
            }
          }else{
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          this.isLoadingBag = false
          console.error(error)
        })
    },
    gettotalshipments(data) {
      var totalShipments = 0;
      if(!data){
        data = this.BagDetailsArray;
      }
      for (var i = 0; i < data.length; i++) {
        totalShipments = totalShipments + parseInt(data[i].bagshipmentscnt)
      }
      return totalShipments;
    },
    getBagOctroilList(data) {
      localStorage.setItem('pageName','BagDetailsInvoice');
      if (data.connectionschedulemasterid == '' || data.connectionschedulemasterid == undefined || data.connectionschedulemasterid == null) {
        this.$alertify.error('Connection Schedule Master ID Not Found');
        return false
      }
      let routeData = this.$router.resolve("/generateBagOctroilListPrint/" + data.connectionschedulemasterid + "/" + this.Hubid)
      window.open(routeData.href, '_blank');
    },

    getHubDetails() {
      this.gstregnoLoading = 'Loading GSTRegNo...'
      var self = this
      this.input = {
        id: 2 //parseInt(self.DestinationHubID)
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'expose/hubservicecenter/hub/get',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.gstregnoLoading = ''
          var HubDetails = result.data.ResponseData
          if (HubDetails.length > 0) {
            this.GSTRegNo = HubDetails[0].gstregistrationno;
          }
        }, error => {
          console.error(error)
        })
    },
    selectConnectionType(connectiontypeitem) {
      this.connectiontypeitem = connectiontypeitem
      this.connectiontype = this.connectiontypeitem.text
      this.connectionnamelist = []
      this.connectionnameitem = {
        id: '',
        text: '',
        route: ''
      }
      this.actualRoute = ""
      if (this.hubnameitem.text != '' && this.connectiontype != '') {
        this.getConnectionName()
      }
    },
    selectHubName(hubnameitem) {
      this.hubnameitem = hubnameitem
      this.hubname = this.hubnameitem.id
      this.connectionnamelist = []
      this.connectionnameitem = {
        id: '',
        text: '',
        route: ''
      }
      this.connectionname = ''
      this.actualRoute = ''
      this.$validator.reset()
      if (this.hubnameitem.text != '' && this.connectiontype != '') {
        this.getConnectionName()
      }
    },
    selectConnectionName(connectionnameitem) {
      this.connectionnameitem = connectionnameitem
      this.connectionname = this.connectionnameitem.text
      this.actualRoute = connectionnameitem.route
    },
    hideBagListmodel() {
      this.viewBagListmodel = false;
      this.viewBrooksNdBondModel = false;
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
    },
    hideBagOctroilListModel() {
      this.viewBagOctroilListModel = false;
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
    },
    printClientwiseManifest(data) {
      localStorage.setItem('pageName','BagDetailsInvoice');
      if (data.connectionschedulemasterid == '' || data.connectionschedulemasterid == undefined || data.connectionschedulemasterid == null) {
        this.$alertify.error('Connection Schedule Master ID Not Found');
        return false
      }
      let routeData = this.$router.resolve("/TripGenerateConnectionPrint/" + data.connectionschedulemasterid + "/" + parseInt(this.connectiontypeitem.id)  + "/" +  this.Hubid)
      window.open(routeData.href, '_blank');
    },
    printInvoice() {
      const d = new Printd();
      var buffer = '';

      var cssText = `
           body{
               -webkit-print-color-adjust:exact;
               font-family: Roboto,sans-serif;
           }
           table {
               border-collapse: collapse;
               margin-left:0px !important;
           }
           table, td, th {
             border-style: solid;
             border-width: 1px;
             padding:5px;
           }
           .text-right{
             text-align:right;
           }
           .text-left{
             text-align:left;
           }
           .text-center{
             text-align:center;
           }
           .h3-center-text{
             text-align:center;
           }
           @media print {
           .text-primary th{
             background-color:rgb(226, 216, 216) !important;
             color:black !important;
             font-size:20px !important;
           }
          }
          `

      if(this.connectiontypeitem && this.connectiontypeitem.id == 5){
        d.print(document.getElementById('BagDetailsInvoiceBB'), cssText);
      }else{
        d.print(document.getElementById('BagDetailsInvoice'), cssText);
      }
    },
    printOctroilList() {
      const d = new Printd();
      var buffer = '';

      var cssText = `
           body{
               -webkit-print-color-adjust:exact;
               font-family: Roboto,sans-serif;
           }
           table {
               border-collapse: collapse;
               margin-left:0px !important;
           }
           table, td, th {
             border-style: solid;
             border-width: 1px;
             padding:5px;
           }
           .text-right{
             text-align:right;
           }
           .text-left{
             text-align:left;
           }
           .text-center{
             text-align:center;
           }
           .h3-center-text{
             text-align:center;
           }
           @media print {
           .text-primary th{
             background-color:rgb(226, 216, 216) !important;
             color:black !important;
             font-size:20px !important;
           }
          }
          `
      d.print(document.getElementById('BagOctroilListArray'), cssText);
    },
    onSubmit: function() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pageNo = 0
          this.getInvoiceList()
        } else {
          console.log('errors exist', this.errors)
        }
      }).catch(() => {
        console.log('errors exist')
      });
    },
    resetFormForMail(){
      this.mailId='',
      this.emailIdErrorMSG='',
      this.emailIdValidationMSG=''
    },
    SendMailFunction(){
      this.emailIdValidationMSG=''
      this.emailIdErrorMSG=''
      if(this.mailId =='' || this.mailId == undefined)
      {
        this.emailIdErrorMSG="Enter Email-Id"
        return false
      }
      var mailArray=[];
      mailArray = this.mailId.split(',');
      for(var i=0;i<mailArray.length;i++) {
        if(this.regForMail.test(mailArray[i]) == false)
        {
          this.emailIdValidationMSG="Invalid MailId"+" "+mailArray[i]
          return false
        }
      }

      // let api = 'emailBagDetailsForGenerateInvoice';
      let api = (this.connectiontypeitem && this.connectiontypeitem.id == 5) ? 'emailBagDetailsForGenerateInvoiceBrookBond' : 'emailBagDetailsForGenerateInvoice';

      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops + api + '?invoiceNo=' + this.InvoiceNo + '&emailId=' + this.mailId + '&createdBy=' + this.createdBy ,
          data: this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25'
          }
        }).then(result => {
          var response = result.data
          if (response.ResultCode == 100) {
            this.$alertify.success(response.ReturnMessage)
            this.resetFormForMail()
          } else {
            this.$alertify.error(response.ReturnMessage)
          }
          this.isLoading = false
        }, error => {
          this.isLoading = false
          console.error(error)
        })

    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/BagDetailsInvoice/BagDetailsInvoice.js